import { render, staticRenderFns } from "./ShowCustomerFormat.vue?vue&type=template&id=96d8b928&scoped=true&"
import script from "./ShowCustomerFormat.vue?vue&type=script&lang=js&"
export * from "./ShowCustomerFormat.vue?vue&type=script&lang=js&"
import style0 from "./ShowCustomerFormat.vue?vue&type=style&index=0&id=96d8b928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8b928",
  null
  
)

export default component.exports